<template>
  <div class="mb-4">
    <b-card no-body class="border-none">
      <div class="mt-2">
        <div class="post-input hola mb-4">
          <div class="flex gap-2 items-center">
            <b-avatar variant="info" class="p-3 cust-avatar"></b-avatar>
            <div class="flex relative w-full">
              <b-input
                v-model="comment"
                @keypress.enter="addComment()"
                class="ml-2 rounded-full border-1"
                placeholder="Type a comment..."
              />
              <div
                class="absolute right-6 cursor-pointer pt-2.5 font-semibold text-sm top-3"
                @click="addComment"
              >
                Comment
              </div>
            </div>
          </div>
        </div>
        <div class="my-2">
          <!-- <b-dropdown
            size="lg"
            variant="link"
            toggle-class="text-decoration-none py-1 px-2"
            no-caret
            dropleft
          > -->
          <!-- <template>
            <div class="flex my-icon cursor-pointer my-4">
              <p class="text-sm font-semibold darktext">
                Read more comments...
              </p>-->
          <!-- <feather-icon
                  class="cursor-pointer"
                  icon="ChevronDownIcon"
                  svgClasses="w-4 h-4 my-auto ml-1 darktext flex"
                ></feather-icon> -->
          <!--     </div>
          </template>-->
          <!-- <b-dropdown-item href="#">Leave</b-dropdown-item> -->
          <!-- <b-dropdown-item class="p-0">
              <div class="flex">
                <div class="w-1/12 m-auto">
                  <feather-icon icon="ZapIcon" class=""></feather-icon>
                </div>
                <div class="w-11/12 ml-4">
                  <p class="text-base font-semibold">Most Relevant</p>
                  <p class="text-sm">See the most relevant comments</p>
                </div>
              </div>
            </b-dropdown-item>
            <b-dropdown-item href="#"
              ><div class="flex">
                <div class="w-1/12 m-auto">
                  <feather-icon icon="ClockIcon" class=""></feather-icon>
                </div>
                <div class="w-11/12 ml-4">
                  <p class="text-base font-semibold">Most Recent</p>
                  <p class="text-sm">
                    See all comments, the most recent<br />
                    comments are first.
                  </p>
                </div>
              </div></b-dropdown-item
            > -->
          <!-- </b-dropdown> -->
        </div>
        <div class="post-input" v-for="Comment in comments" :key="Comment._id">
          <div>
            <div>
              <div class="flex items-center">
                <!-- <div>-->
                <img
                  alt="user"
                  class="rounded-full w-8 h-8"
                  :src="`${$imageURL}/${Comment._user.userImage}`"
                  v-if="
                    Comment._user.hasOwnProperty('userImage') &&
                    Comment._user.userImage !== 'null' &&
                    Comment._user.userImage.trim() !== '' &&
                    Comment._user.userImage !== null
                  "
                />
                <b-avatar
                  v-else
                  variant="info"
                  class="p-3 cust-avatar"
                  size="lg"
                ></b-avatar>
                <!--- <b-avatar variant="primary" class="p-4 avatar"></b-avatar>
                </div> -->
                <!-- <b-avatar variant="info" class="p-3 cust-avatar"></b-avatar> -->
                <div class="bgf4f5f6 rounded-2xl px-4 pt-2 pb-4 ml-2 w-full">
                  <div class="flex justify-between items-center">
                    <h1
                      class="font-semibold text-sm"
                      v-if="Comment._user != null && !Comment._user.isAnonymous"
                    >
                      <!-- <template v-if="!Comment.isAnonymous"> -->
                      {{ Comment._user.firstname }}
                      {{ Comment._user.lastname }}
                    </h1>
                    <!-- </template> -->
                    <h1
                      class="font-semibold text-sm"
                      v-if="Comment._user != null && Comment._user.isAnonymous"
                    >
                      Anonymous User
                    </h1>
                    <b-dropdown
                      size="lg"
                      variant="link"
                      toggle-class="text-decoration-none py-2 px-2"
                      no-caret
                      dropleft
                    >
                      <template #button-content>
                        <feather-icon
                          class="cursor-pointer"
                          icon="MoreHorizontalIcon"
                          svgClasses="w-4 h-4"
                        ></feather-icon>
                      </template>
                      <!--  <b-dropdown-item href="#"
                        ><div class="flex">
                          <div class="w-1/6 m-auto">
                            <feather-icon
                              icon="EditIcon"
                              class="darktext w20px"
                            ></feather-icon>
                          </div>
                          <div class="w-5/6">
                            <p class="text-base darktext">Edit</p>
                          </div>
                        </div></b-dropdown-item
                      >-->
                      <b-dropdown-item
                        href="#"
                        v-if="
                          userData._id == Comment._user._id ||
                          userData.role == 'admin'
                        "
                        ><div class="flex" @click="deleteComment(Comment)">
                          <div class="w-1/6 m-auto">
                            <feather-icon
                              icon="Trash2Icon"
                              class="darktext w20px"
                            ></feather-icon>
                          </div>
                          <div class="w-5/6">
                            <p class="text-base darktext">Delete</p>
                          </div>
                        </div></b-dropdown-item
                      >
                      <b-dropdown-item href="#"
                        ><div class="flex" @click="reportComment(Comment._id)">
                          <div class="w-1/6 m-auto">
                            <feather-icon
                              icon="FlagIcon"
                              class="darktext w20px"
                            ></feather-icon>
                          </div>
                          <div class="w-5/6">
                            <p class="text-base darktext">Report</p>
                          </div>
                        </div></b-dropdown-item
                      >
                      <!--  <b-dropdown-item href="#"
                        ><div class="flex">
                          <div class="w-1/6 m-auto">
                            <feather-icon
                              icon="FlagIcon"
                              class="darktext w20px"
                            ></feather-icon>
                          </div>
                          <div class="w-5/6">
                            <p class="text-base darktext">Report</p>
                          </div>
                        </div></b-dropdown-item
                      >-->
                    </b-dropdown>
                  </div>
                  <p class="text-sm text-muteddark font-normal">
                    {{ Comment.comment }}
                  </p>
                </div>
              </div>

              <div class="flex items-center m-auto w-83per mt-2">
                <LikeReply
                  liketype="Comment"
                  :commentID="Comment._id"
                  :commentData="Comment"
                />
                <p
                  @click="selectedCommentId = Comment._id"
                  class="text-xs font-bold mr-2 cursor-pointer hover:underline"
                >
                  Reply ({{ Comment.totalReplies }})
                </p>
                <p class="text-xs font-medium">
                  {{ commentTime(Comment.createdAt) }}
                </p>
              </div>
            </div>
            <Reply
              :postId="postId"
              :commentId="Comment._id"
              :showInputBox="Comment._id == selectedCommentId"
            />
            <div class="mt-6" v-if="false">
              <div class="m-auto w-83per">
                <div class="flex">
                  <div>
                    <!-- <img
                      alt="user"
                      class="w-8 rounded-full"
                      :src="item.userImg"
                    /> -->
                  </div>

                  <div class="bgf4f5f6 rounded-lg px-4 py-2 w-auto ml-3">
                    <div class="flex justify-between items-center">
                      <h1 class="font-semibold text-xs">John Doe</h1>
                      <b-dropdown
                        size="lg"
                        variant="link"
                        toggle-class="text-decoration-none py-2 px-0"
                        no-caret
                        dropleft
                      >
                        <template #button-content>
                          <feather-icon
                            class="cursor-pointer"
                            icon="ChevronDownIcon"
                            svgClasses="w-4 h-4"
                          ></feather-icon>
                        </template>
                        <!-- <b-dropdown-item href="#">Leave</b-dropdown-item> -->
                        <b-dropdown-item href="#">Edit</b-dropdown-item>
                        <b-dropdown-item href="#">Delete</b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <p class="text-xs text-muted font-normal">
                      Lorem ipsum dolor sit amet.
                    </p>
                  </div>
                </div>
                <div class="flex items-center m-auto w-83per mt-2">
                  <p
                    class="text-xs font-bold mr-2 cursor-pointer hover:underline"
                  >
                    Like
                  </p>
                  <p
                    class="text-xs font-bold mr-2 cursor-pointer hover:underline"
                  >
                    Reply
                  </p>
                  <p class="text-xs font-medium">1d</p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex items-center justify-between w-full pt-6 pb-2"
            v-if="false"
          >
            <h2 class="font-semibold text-sm hover:underline cursor-pointer">
              View more comment
            </h2>
            <p class="text-sm font-medium">21 of 212</p>
          </div>
        </div>
        <!-- <div role="tablist" class="accordion mt-2">
          <b-card no-body class="mb-1">
            <b-card-header
              header-tag="header"
              href="#"
              role="tab"
              v-b-toggle.accordion-1
              class="p-4 cursor-pointer"
            >
              <div class="flex justify-between">
                <h5 class="mb-0 text-md texta9a9a9">
                  Organic impressions: 0 Impressions
                </h5>
                <div class="flex items-center">
                  <p class="font-medium text-sm pr-3 texta9a9a9">Show Stats</p>
                  <feather-icon icon="ChevronDownIcon" svgClasses="w-4 h-4" />
                </div>
              </div>
            </b-card-header>
            <b-collapse
              id="accordion-1"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <div class="title">
                  <span class=" font-medium cust-greycolor">Organic stats</span>
                  <p class="cust-greydark text-sm">
                    Targeted to: All followers
                  </p>
                </div>

                <div class="flex mt-4 flex-wrap justify-between">
                  <div class="p-3">
                    <p class="cust-greydark font-bold fsize20">0</p>
                    <p class="cust-greydark">Impressions</p>
                  </div>

                  <div class="p-3">
                    <p class="cust-greydark font-bold fsize20">0</p>
                    <p class="cust-greydark">Reactions</p>
                  </div>

                  <div class="p-3">
                    <p class="cust-greydark font-bold fsize20">0</p>
                    <p class="cust-greydark">Comments</p>
                  </div>

                  <div class="p-3">
                    <p class="cust-greydark font-bold fsize20">0</p>
                    <p class="cust-greydark">Shares</p>
                  </div>

                  <div class="p-3">
                    <p class="cust-greydark font-bold fsize20">27.78%</p>
                    <p class="cust-greydark">Engagement rate</p>
                  </div>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div> -->
      </div>
    </b-card>
  </div>
</template>

<script>
import FeatherIcon from "../../../components/FeatherIcon.vue";
import Reply from "./Reply.vue";
import LikeReply from "./LikeReply.vue";
import { mapState } from "vuex";
export default {
  components: { FeatherIcon, Reply, LikeReply },
  props: {
    postId: {
      type: String,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      comment: "",
      selectedCommentId: "",
    };
  },
  methods: {
    commentTime(time) {
      const distanceInWordsToNow = require("date-fns/distance_in_words_to_now");
      return `${distanceInWordsToNow(time)} ago`;
    },
    async addComment() {
      let Comment = {
        postId: this.postId,
        comment: this.comment,
      };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("posts/addComment", Comment);
        this.comment = "";
        await this.$store.dispatch("channel/GetChannel", {
          channelID: this.selectedChannel._id,
        });
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async reportComment(id) {
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("posts/editComment", {
          commentID: id,
          reported: "yes",
        });
        if (data.code === 200) {
          this.$swal("Reported!", "Comment has been reported", "success");
        }
        await this.$store.dispatch("channel/GetChannel", {
          channelID: this.selectedChannel._id,
        });
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async deleteComment(Comment) {
      let loader = this.$loading();
      try {
        await this.$store.dispatch("posts/deleteComment", Comment);
        await this.$store.dispatch("channel/GetChannel", {
          channelID: this.selectedChannel._id,
        });
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    test() {
      // console.log(this.postComments);
    },
  },
  mounted() {
    // console.log(this.postComments, "****");
    this.$store.dispatch("eLearning/getProfile", {
      userId: this.userData._id,
    });
    this.test();
    // console.log(this.comments, "Comments");
  },
  computed: {
    ...mapState("posts", {
      postComments: "postComments",
      currentuserpostComments: "currentuserpostComments",
    }),
    ...mapState("channel", {
      selectedChannel: "selectedChannel",
    }),
    ...mapState("auth", {
      userData: "user",
    }),
    comments() {
      return (
        this.postComments[this.postId] ||
        this.currentuserpostComments[this.postId]
      );
    },
  },
};
</script>
